import { Mail } from "lucide-react";
import { useAuthStep } from "@/hooks/useAuthStep";
import GoogleAuthBtn from "@/components/GoogleAuthBtn";
import { GoogleSvg, OutlookSvg } from "@/lib/svg.tsx";
import { useEffect } from "react";
import { trackEvent } from "@/lib/utils";


const Logins = () => {
    const { setAuthStep, uuid } = useAuthStep();

    useEffect(() => {
        trackEvent("signup_logins_loaded", { "distinct_id": uuid });
    }, []);

    return (
        <div className="px-[30px] flex flex-col h-full">
            <div>
                <h1 className="text-2xl font-semibold mb-[5px]">Join now (takes 30 secs)</h1>
                <p className="text-gray-500">Over 1.5 million students made their Canvas better</p>
            </div>
            <div className="font-medium my-5 flex flex-col gap-1 ml-1">
                <p><span className="mr-[5px]">🎨</span> Make canvas your own</p>
                <p><span className="mr-[5px]">✅</span> Stay on top of every assignment</p>
                <p><span className="mr-[5px]">⚡</span> Study faster and smarter</p>
            </div>
            <div className="flex flex-col gap-[10px] mt-[10px]">
                <button onClick={() => setAuthStep("googleSignup")} className="bg-white hover:brightness-95 transition-all duration-200 flex justify-center items-center rounded-xl w-full p-3.5 border border-[#e5e5e5] gap-[10px] font-medium">
                    <GoogleSvg className="w-[20px] h-[20px]" />
                    <span>Continue with Google</span>
                </button>
                <div>
                    <button onClick={() => setAuthStep("outlookSignup")} className="bg-white hover:brightness-95 transition-all duration-200 flex justify-center items-center rounded-xl w-full p-3.5 border border-[#e5e5e5] gap-[10px] font-medium">
                        <OutlookSvg className="w-[20px] h-[20px]" />
                        <span>Continue with Outlook</span>
                    </button>
                </div>
            </div>
            <div className="my-4">
                <div className="h-[1px] bg-gray-200 w-full relative">
                    <div className="text-gray-500 text-center text-sm w-full h-full absolute left-0 top-0 flex items-center justify-center">
                        <span className="bg-white px-2 text-xs">OR</span>
                    </div>
                </div>
            </div>
            <div>
                <button onClick={() => setAuthStep("emailSignup")} className="bg-white hover:brightness-95 transition-all duration-200 flex justify-center items-center rounded-xl w-full p-3.5 border border-[#e5e5e5] gap-[10px] font-medium">
                    <Mail className="w-[20px] h-[20px]" />
                    <span>Continue with Email</span>
                </button>
            </div>
            <div className="flex flex-col gap-[10px] flex-1 mb-[30px]">
                <div className="mt-auto w-full text-sm p-[10px] text-gray-500 text-center">
                    Already have an account? <a href="/login" className="underline font-medium text-black">Log in</a>
                </div>
            </div>
        </div>
    );
};

export default Logins;
